exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".abnormal-modal-main[data-v-582e24ba],.abnormal-modal-main .abnormal-modal-form[data-v-582e24ba]{position:relative}.abnormal-modal-main .abnormal-modal-form .abnormal-tips-txt[data-v-582e24ba]{padding:20px 50px;font-size:20px;font-weight:700}.abnormal-modal-main .abnormal-modal-form .abnormal-error-tips[data-v-582e24ba]{color:#f20}.abnormal-modal-main .abnormal-modal-form .two-col-grid[data-v-582e24ba]{display:grid;grid-template-columns:repeat(auto-fill,calc(50% - 10px));gap:10px}", ""]);

// exports
